import { configFactory, getOrThrow } from '@digitsole/blackburn-configuration';

export const cognitoConfig = configFactory({
  region: getOrThrow('region', { type: 'string', prefix: 'blackburn' }) as string,
  userPoolId: getOrThrow('auth.pool.id', { type: 'string', prefix: 'blackburn' }) as string,
  userPoolWebClientId: getOrThrow('auth.client.id', { type: 'string', prefix: 'blackburn' }) as string,
  identityPoolId: getOrThrow('auth.identity.pool.id', { type: 'string', prefix: 'blackburn' }) as string
});
